import { gsap } from 'gsap';
import Headroom from 'headroom.js';
import { headerHeight, announcementBarHeight } from '../helpers';
import { openMinicart } from './minicart';

if (!window.dAgency) window.dAgency = {};

$(function () {
  const $siteHeader = $('.site-header');
  const $header = $siteHeader.find('.header__container');
  if ($siteHeader <= 0 || $header.length <= 0) return false;

  $('html:not(.template-page-faq-with-section-prod)').css('scroll-padding-top', headerHeight() + 'px');
  $('#PageContainer').css(
    'min-height',
    'calc(100vh - ' + headerHeight() + 'px)',
  );
  $('#CartPopup').css('top', headerHeight() + 'px');

  $(window).on('resize', function () {
    $('html:not(.template-page-faq-with-section-prod)').css('scroll-padding-top', headerHeight() + 'px');
    $('#PageContainer').css(
      'min-height',
      'calc(100vh - ' + headerHeight() + 'px)',
    );
    $('#CartPopup').css('top', headerHeight() + 'px');
  });

  /* ======================== Header ======================== */
  if ($header.hasClass('header__transparent')) {
    if ($(window).scrollTop() === 0) {
      $header.addClass('apply-transparency');
    } else {
      $header.removeClass('apply-transparency');
    }

    $(window).on('scroll', function () {
      if (!$header.hasClass('force-opacity')) {
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        } else {
          $header.removeClass('apply-transparency');
        }
      }
    });
  }

  $header.on('mouseenter', function () {
    if ($(window).outerWidth() > 1024) {
      $header.removeClass('apply-transparency');
    }
  });
  $header.on('mouseleave', function () {
    if (
      $(window).scrollTop() === 0 &&
      $(window).outerWidth() > 1024 &&
      !$header.hasClass('force-opacity')
    ) {
      $header.addClass('apply-transparency');
    }
  });

  $header.find('.header__left__newsletter-button').on('click', function () {
    if (typeof window.dAgency.showNewsletterPopUp === 'function')
      window.dAgency.showNewsletterPopUp();
  });

  const $cartLink = $header.find('.cart-link');
  if ($cartLink.length) {
    $cartLink.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      $header.removeClass('apply-transparency');
      $header.addClass('force-opacity');
      openMinicart();
    });
  }

  /* ======================== Mobile Menu ======================== */
  const $mobileMenu = $header.find('.header__mobile-menu');
  if ($mobileMenu.length > 0) {
    // The drawer is fixed. Its top follows the scroll while the announcement bar
    // scrolls away, then clamps to the header height once the header is sticky
    // (so it starts right below the pinned header).
    //   top = max(headerHeight, announcementHeight + headerHeight - scrollY)
    const applyMobileMenuOffset = () => {
      const headerH = $header[0].clientHeight;
      const top = Math.max(
        headerH,
        announcementBarHeight() + headerH - window.scrollY,
      );
      $mobileMenu.css('top', top + 'px');
      $mobileMenu.css('height', 'calc(100dvh - ' + top + 'px)');
    };

    applyMobileMenuOffset();

    let recalcScheduled = false;
    const scheduleMobileMenuRecalc = () => {
      if (recalcScheduled) return;
      recalcScheduled = true;
      requestAnimationFrame(() => {
        recalcScheduled = false;
        applyMobileMenuOffset();
      });
    };

    // Follow scroll so the drawer stays glued to the header bottom as the
    // announcement scrolls away and the header sticks to the top.
    window.addEventListener('scroll', scheduleMobileMenuRecalc, { passive: true });
    window.addEventListener('resize', scheduleMobileMenuRecalc, { passive: true });

    // Recalc when Global-e injects (or removes) the top-of-page banner. It is
    // appended as a direct child of <body>, so we only watch body's direct children.
    const GE_SELECTOR = '#FreeShippingBanner';
    if ('MutationObserver' in window) {
      new MutationObserver((mutations) => {
        const geTouched = mutations.some((m) =>
          [...m.addedNodes, ...m.removedNodes].some(
            (n) =>
              n.nodeType === 1 &&
              (n.matches?.(GE_SELECTOR) || n.querySelector?.(GE_SELECTOR)),
          ),
        );
        if (geTouched) scheduleMobileMenuRecalc();
      }).observe(document.body, { childList: true, subtree: false });
    }

    const $firstLevel = $mobileMenu.find(
      '.header__mobile-menu--drawer__first-level__title',
    );
    const $firstLevelWrapper = $mobileMenu.find(
      '.header__mobile-menu--drawer__first-level',
    );
    $firstLevel.each(function () {
      const submenu = $(this).data('submenu');
      const $connectedSecondLevel = $mobileMenu.find(
        '.header__mobile-menu--drawer__second-level[data-submenu="' +
          submenu +
          '"]',
      );

      const $secondLevelTitles = $.find(
        '.header__mobile-menu--drawer__second-level__title',
      );
    });

    $firstLevelWrapper.each(function () {
      const $level = $(this);

      $firstLevel.each(function () {
        const accordionIndex = $(this).data('submenu');
        const $connectedSecondLevel = $mobileMenu.find(
          '.header__mobile-menu--drawer__second-level[data-submenu="' +
          accordionIndex +
            '"]',
        );
        const $otherSecondLevels = $level.find(
          '.header__mobile-menu--drawer__second-level:not([data-submenu="' +
            accordionIndex +
            '"])',
        );


        $(this).on('click', function (e) {
          if (e.target.getAttribute('href')) return;

          if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $connectedSecondLevel.slideUp();
          } else {
            $firstLevel.removeClass('open');
            $otherSecondLevels.slideUp();
            $(this).addClass('open');
            $connectedSecondLevel.slideDown();
          }
        });
      });
    });

    const $secondLevel = $mobileMenu.find(
      '.header__mobile-menu--drawer__second-level',
    );
    $secondLevel.each(function () {
      const $level = $(this);

      const $titles = $(this).find(
        '.header__mobile-menu--drawer__second-level__title',
      );
      $titles.each(function () {
        const accordionIndex = $(this).data('accordion-index');
        const $otherThirdLevels = $level.find(
          '.header__mobile-menu--drawer__third-level:not([data-accordion-index="' +
            accordionIndex +
            '"])',
        );
        const $connectedThirdLevel = $level.find(
          '.header__mobile-menu--drawer__third-level[data-accordion-index="' +
            accordionIndex +
            '"]',
        );

        $(this).on('click', function (e) {
          if (e.target.getAttribute('href')) return;

          if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $connectedThirdLevel.slideUp();
          } else {
            $titles.removeClass('open');
            $otherThirdLevels.slideUp();
            $(this).addClass('open');
            $connectedThirdLevel.slideDown();
          }
        });
      });
    });


    const burgerTop = document.getElementById('burger-bar-top');
    const burgerMiddle = document.getElementById('burger-bar-middle');
    const burgerBottom = document.getElementById('burger-bar-bottom');
    var tl = gsap.timeline();

    var isMenuOpen = false;
    $header.find('.header__burger-icon').on('click', function () {
      isMenuOpen = !isMenuOpen;
      $mobileMenu.toggleClass('open');
      if (isMenuOpen) {
        $('html').css('overflow-y', 'hidden');
        $header.removeClass('apply-transparency');
        $header.addClass('force-opacity');
        $(this).addClass('open');
        tl = gsap.timeline();
        tl.to(
          burgerTop,
          {
            rotate: 45,
            duration: 1,
            y: 7,
            transformOrigin: 'center',
            ease: 'power2.out',
          },
          0,
        );
        tl.to(
          burgerMiddle,
          {
            scaleX: 0,
            duration: 1,
            opacity: 0,
            transformOrigin: 'center',
            ease: 'power2.out',
          },
          0,
        );
        tl.to(
          burgerBottom,
          {
            rotate: -45,
            duration: 1,
            y: -7,
            transformOrigin: 'center',
            ease: 'power2.out',
          },
          0,
        );
      } else {
        $(this).removeClass('open');
        $('html').css('overflow-y', '');
        const $predictiveInput = $header.find('.predictive-search__form input[type="search"]');
        const $predictiveResults = $header.find('#results-wrapper');
        $predictiveInput.val('');
        $predictiveResults.removeClass('open');
        $header.removeClass('force-opacity');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }

        tl = gsap.timeline();
        tl.to(
          burgerTop,
          {
            rotate: 0,
            duration: 1,
            y: 0,
            transformOrigin: 'center',
            ease: 'power2.out',
          },
          0,
        );
        tl.to(
          burgerMiddle,
          {
            scaleX: 1,
            duration: 1,
            opacity: 1,
            transformOrigin: 'center',
            ease: 'power2.out',
          },
          0,
        );
        tl.to(
          burgerBottom,
          {
            rotate: 0,
            duration: 1,
            y: 0,
            transformOrigin: 'center',
            ease: 'power2.out',
          },
          0,
        );
      }
    });

    const $mobileMenuImages = $('.header__mobile-menu__level__image');
    if ($mobileMenuImages.length > 0) {
      $mobileMenuImages.each(function () {
        const $links = $(this).prev();
        $links.css(
          'height',
          'calc(100% - ' + $(this).innerHeight() + 'px - 1rem)',
        );
      });
    }

    $('[data-mobile-menu-opener]').on('click', function (e) {
      if (!e.target.getAttribute('href')) {
        const menuName = $(this).data('mobile-menu-opener');
        $('[data-mobile-menu="' + menuName + '"]').css(
          'transform',
          'translate3d(0, 0, 0)',
        );
      }
    });

    $('[data-mobile-menu] .header__mobile-menu__level__title').on(
      'click',
      function () {
        const $menu = $(this).closest('.header__mobile-menu__level');
        $menu.css('transform', '');
      },
    );
  }

  /* ======================== Desktop Menu ======================== */
  const $desktopMenu = $header.find('.header__desktop-menu');
  if ($desktopMenu.length > 0) {
    if ($desktopMenu.hasClass('header__desktop-menu--dropdown')) {
      const $dropdownInlineElements = $desktopMenu.find(
        '.header__desktop-menu--dropdown__inline-elements__link',
      );
      $dropdownInlineElements.each(function () {
        if (
          $desktopMenu.hasClass(
            'header__desktop-menu--dropdown--alternative',
          ) &&
          $(this).find('.header__desktop-menu--dropdown__navigation__element')
            .length <= 0
        )
          return;

        // Close runs on a cancellable timer: re-entering before it fires must
        // keep the dropdown open, otherwise it closes under the cursor.
        let closeTimeout = null;

        $(this).on('mouseenter', function () {
          clearTimeout(closeTimeout);

          const $menuElementContainer = $(this).find(
            '.header__desktop-menu--dropdown__dropdown-wrapper',
          );
          const $menuElementOpener= $(this).find(
            '.underline-hover.uppercase',
          );
          $menuElementContainer.addClass('open');
          $menuElementOpener.addClass('open');

          this
            .querySelectorAll('.stop_image_loading')
            .forEach((el) => el.classList.remove('stop_image_loading'));

          $menuElementContainer.css(
            'max-height',
            'calc(100vh - ' + headerHeight() + 'px)',
          );

          $header.addClass('force-opacity');
        });

          $(this).on('mouseleave', function () {
            closeTimeout = setTimeout(() => {
              $(this)
                .find('.header__desktop-menu--dropdown__dropdown-wrapper')
                .removeClass('open');

              const $menuElementOpener = $(this).find('.underline-hover.uppercase');
              $menuElementOpener.removeClass('open');

              // Another item may have opened its dropdown in the meantime:
              // only drop the header opacity when no dropdown is left open.
              if (
                $desktopMenu.find(
                  '.header__desktop-menu--dropdown__dropdown-wrapper.open',
                ).length <= 0
              ) {
                $header.removeClass('force-opacity');
              }
            }, 150);
          });
        });

      if (
        $desktopMenu.hasClass('header__desktop-menu--dropdown--alternative')
      ) {
        const $sliders = $desktopMenu.find(
          '.header__desktop-menu--dropdown__navigation',
        );
        $sliders.each(function () {
          window.dAgency.initDesktopSlider(this, 2);
        });
      } else {
        $desktopMenu
          .find('.header__desktop-menu--dropdown__navigation')
          .each(function () {
            const $mediaContainer = $(this).find(
              '.header__desktop-menu--dropdown__navigation__media',
            );
            const $titleWithImages = $(this).find('[data-image-src]');

            $titleWithImages.on('mouseenter', function () {
              const imgSrc = $(this).data('image-src');
              const $img = $mediaContainer.find('[srcset*="' + imgSrc + '"]');

              $mediaContainer
                .find(
                  '.header__desktop-menu--dropdown__navigation__media__img.active',
                )
                .removeClass('active');
              $img.addClass('active');
            });
          });

        const $menuCarousel = $desktopMenu.find(
          '.header__desktop-menu--dropdown__carousel__blocks',
        );
        if ($menuCarousel.length > 0) {
          $menuCarousel.each(function () {
            const slider = $(this)[0];
            if (slider.scrollWidth <= slider.clientWidth) {
              $(this).css('justify-content', 'center');
            } else {
              window.dAgency.initDesktopSlider(slider, 2);
            }
          });
        }
      }
    } else if ($desktopMenu.hasClass('header__desktop-menu--drawer')) {
      const $firstLevelLinks = $desktopMenu.find(
        '.header__desktop-menu--drawer__inline-elements__link',
      );
      $firstLevelLinks.each(function () {
        $(this).on('mouseenter', function () {
          if ($(window).outerWidth() <= 1024) return;

          $header.addClass('force-opacity');
          $(this).addClass('open');
          $('html').css('overflow-y', 'hidden');
        });

        $(this).on('mouseleave', function () {
          if ($(window).outerWidth() <= 1024) return;

          $header.removeClass('force-opacity');
          $(this).removeClass('open');
          $(this).find('.open').removeClass('open');
          $('html').css('overflow-y', '');
        });
      });

      $desktopMenu
        .find('.header__desktop-menu--drawer__second-level')
        .each(function () {
          $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');

          const $level = $(this);
          $(this)
            .find(
              '.header__desktop-menu--drawer__second-level__title.clickable',
            )
            .on('click', function (e) {
              if (e.target.getAttribute('href')) return;

              const levelIndex = $(this).data('submenu');
              $level
                .find(
                  '.header__desktop-menu--drawer__third-level[data-submenu="' +
                    levelIndex +
                    '"]',
                )
                .addClass('open');
            });
        });

      $(this)
        .find('.header__desktop-menu--drawer__third-level')
        .each(function () {
          const $thirdLevel = $(this);
          const $overflowContainer = $(this).find(
            '.header__desktop-menu--drawer__third-level__overflow-container',
          );
          const $goBack = $(this).find(
            '.header__desktop-menu--drawer__third-level__go-back',
          );

          $overflowContainer.css(
            'height',
            'calc(100% - ' + $goBack.outerHeight() + 'px)',
          );
          $goBack.on('click', function () {
            $thirdLevel.removeClass('open');
          });
        });
    }
  }
});
